export default class SubscriptionResponse {
    transactionId;
    status;
    statusName;
    fromJson=(json={})=> {
        var subscriptionResponse = new SubscriptionResponse();
        subscriptionResponse = json;
        return subscriptionResponse;
    }
}